/**
 * Patients Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import {store} from "../../store";
// States
const state = {
    patients: [],
    patient: {},
    count:0
};

// Getters
const getters = {
    patients: state => {
        return state.patients
    },

    patient: state => {
        return state.patient
    },

    count: state => {
        return state.count
    }
};

// Actions
const actions = {
    getPatients(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data.patients });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPatientsWithMedecinControle(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data.patients });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.PatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getFirstPatientsWithMedecinControle(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data.patients });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.FirstPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getNextPatientsWithMedecinControle(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data.patients });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.NextPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    // get10PatientsWithMedecinControle(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getPatientsHandler', { patients: response.data.patients });
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.Patient.TenPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    // },

    // get15PatientsWithMedecinControle(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getPatientsHandler', { patients: response.data.patients });
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.Patient.FifteenPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    // },

    // get100PatientsWithMedecinControle(context, payload) {
    //     function successCallback(response) {
    //         context.commit('getPatientsHandler', { patients: response.data.patients });
    //     }

    //     function errorCallback(error) {
    //         Vue.swal(
    //             payload.errorMessages.error,
    //             '',
    //             'error'
    //         );
    //     }

    //     const localToken = localStorage.getItem('ms-token');

    //     makeApiRequest(payload.args, apiModel.Patient.HundredPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    // },


    getCountPatientsWithMedecinControle(context, payload) {
        function successCallback(response) {
            context.commit('getCountPatientsHandler', { count: response.data.count });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.CountPatientMedecin, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPatient(context, payload) {
        function successCallback(response) {
            context.commit('getPatientHandler', { patient: response.data.patient });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getSearchPatient(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data });
            // console.log("response.data");
            // console.log(response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Patient.Search, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPatientsDoctor(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data });
            // console.log("response.data");
            // console.log(response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Patient.PatientDoctor, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCountPatientsDoctor(context, payload) {
        function successCallback(response) {
            context.commit('getCountPatientsHandler', { count: response.data });
            // console.log("response.data");
            // console.log(response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Patient.CountPatientDoctor, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getFirstPatientsDoctor(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data });
            // console.log("response.data");
            // console.log(response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Patient.FirstPatientDoctor, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getNextPatientsDoctor(context, payload) {
        function successCallback(response) {
            context.commit('getPatientsHandler', { patients: response.data });
            // console.log("response.data");
            // console.log(response.data);
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        return makeApiRequest(payload.args, apiModel.Patient.NextPatientDoctor, localToken, successCallback, errorCallback, payload.errorMessages);
    },



    createPatient(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            if(payload.args.role == "ama"){
                localStorage.removeItem("role");
                router.push({ name: 'add-afflitation-from-ama', params: {id: response.data.patient.user_id,  nom: payload.args.nom, prenom: payload.args.prenom, email: payload.args.email} });
            }else{
                router.push({ name: 'patient', params: { patient: response.data.patient.slug } });
            }
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updatePatient(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'patient' });
            router.push({ name: 'patient', params: { patient: response.data.patient.slug } });
            // router.push({ name: 'patients' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePatient(context, payload) {
        function successCallback(response) {
            context.commit('deletePatientHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    decedePatient(context, payload) {
        function successCallback(response) {
            context.commit('decedePatientHandler', { patient:response.data.patient });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Decede, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPatientSubscribers(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'patient' });

            router.push({ name: 'patient', params: { patient: response.data.patient.slug } });
            // router.push({ name: 'patient', params: { patient: payload.args.patient } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Subscriber.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    removePatientSubscriber(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            // store.dispatch('findAndRemove', {name: 'patient' });

            router.go();
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Subscriber.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

};

// Mutations
const mutations = {
    getPatientsHandler(state, { patients }) {
        // Update patients state
        state.patients = patients;
    },

    getCountPatientsHandler(state, { count }) {
        // Update patients state
        state.count = count;
    },

    getPatientHandler(state, { patient }) {
        // Update patient state
        state.patient = patient;
    },

    deletePatientHandler(state, { index, successMessage }) {
        let i = state.patients.findIndex(patient => patient.slug === index);

        if (~i) {
            state.patients.splice(i, 1);

            router.push({ name: 'patients' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    decedePatientHandler(state, { patient }) {
        state.patient = patient
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}